import React from "react"
import { Helmet } from "react-helmet"
import Header from "./Header"
import Footer from "./Footer"
import config from "../../config.json"
import "../scss/app.scss"

const Layout = ({ children }) => (
  <div>
    <Helmet>
      <meta name="description" content={`${config.siteDescription}`} />
      <meta property="og:url" content={`${config.siteURL}`} />
      <meta property="og:title" content={`${config.ogTitle}`} />
      <meta name="twitter:card" content="summary" />
      <meta name="twitter:site" content={`${config.twitterHandle}`} />
      <meta name="twitter:creator" content={`${config.twitterHandle}`} />
      <meta name="twitter:url" content={`${config.siteURL}`} />
      <meta name="twitter:title" content={`${config.ogTitle}`} />
      <meta property="og:image" content={`${config.ogImageURL}`} />
      <meta name="keywords" content={`${config.siteKeywords}`} />
    </Helmet>

    <Header />
    {children}
    <Footer />
  </div>
)

export default Layout
